interface CoinProps {
  sym: string;
  size?: "sm" | "md";
}

const SYMBOLS: Record<string, string> = {
  BTC: "₿",
  ETH: "Ξ",
};

export function Coin({ sym, size = "md" }: CoinProps) {
  const cls = sym.toLowerCase();
  const glyph = SYMBOLS[sym] ?? sym.slice(0, 1);
  return (
    <span className={`se-coin ${size === "sm" ? "se-coin-sm" : ""} ${cls}`}>
      {glyph}
    </span>
  );
}
